import React from 'react'
import { Tooltip } from '@material-ui/core'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import { v4 as uuidv4 } from 'uuid'

export function ArrayToObject(array, keyID) {
    const obj = {}
    for (const idx in array) {
        obj[array[idx][keyID]] = array[idx]
    }

    return obj
}

export function RoughSizeOfObject(object) {
    var objectList = []
    var stack = [object]
    var bytes = 0

    while (stack.length) {
        var value = stack.pop()

        if (typeof value === 'boolean') {
            bytes += 4
        } else if (typeof value === 'string') {
            bytes += value.length * 2
        } else if (typeof value === 'number') {
            bytes += 8
        } else if (typeof value === 'object' && objectList.indexOf(value) === -1) {
            objectList.push(value)

            for (var i in value) {
                stack.push(value[i])
            }
        }
    }
    return bytes
}

export function deepCopy(obj) {
    if (obj === null || typeof obj !== 'object' || '_reactInternalFiber' in obj) {
        return obj
    }

    let copy

    if (Array.isArray(obj)) {
        copy = []
        obj.forEach((elem) => {
            copy.push(deepCopy(elem))
        })
    } else {
        copy = {}
        Object.entries(obj).forEach(([key, value]) => {
            copy[key] = key === 'component' ? value : deepCopy(value)
        })
    }

    return copy
}

export function deepCopySpecifiyKey(obj, keys) {
    const specificObj = {}
    Object.entries(obj).forEach(([key, elem]) => {
        if (keys.includes(key)) specificObj[key] = elem
    })

    return deepCopy(specificObj)
}

export function GenerateRandomString() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
}

export function generatePassword(length) {
    // 檢查長度是否在6-20之間
    if (length < 6 || length > 20) {
        return "密碼長度必須在6到20個字元之間";
    }

    // 定義字元集
    const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lowercase = 'abcdefghijklmnopqrstuvwxyz';
    const numbers = '0123456789';
    const symbols = '!@#$%^&*';
    const allChars = uppercase + lowercase + numbers + symbols;

    // 確保每種字元類型至少出現一次
    let password = '';
    password += uppercase[Math.floor(Math.random() * uppercase.length)];
    password += lowercase[Math.floor(Math.random() * lowercase.length)];
    password += numbers[Math.floor(Math.random() * numbers.length)];
    password += symbols[Math.floor(Math.random() * symbols.length)];

    // 填充剩餘長度
    for (let i = password.length; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * allChars.length);
        password += allChars[randomIndex];
    }

    // 隨機打亂密碼
    password = password.split('').sort(() => Math.random() - 0.5).join('');

    return password;
}

export function getRandomLength() {
    return Math.floor(Math.random() * (20 - 6 + 1)) + 6;
}

export function CamelCaseFormatter(string, separator) {
    return string
        ? string
              .split(separator)
              .map((elem, idx) => (idx === 0 ? elem : elem.charAt(0).toUpperCase() + elem.slice(1)))
              .join('')
        : string
}

export function GetBoolean(value) {
    switch (value) {
        case true:
        case 'true':
            return true
        default:
            return false
    }
}

export function ClearArray(array) {
    array.splice(0, array.length)
}

export function GenerateInfoTooltip(msgs) {
    return (
        <Tooltip
            placement="right"
            title={msgs.map((msg) => (
                <div key={uuidv4()}>{msg}</div>
            ))}>
            <InfoOutlinedIcon style={{ color: '#bbb', width: '20px', marginLeft: '3px' }}></InfoOutlinedIcon>
        </Tooltip>
    )
}

export function IsObjEmpty(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object
}

export function generateRandomString(length) {
    var result = ''
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    var charactersLength = characters.length
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
}

export function goTop() {
    window.scrollTo({
        top: 0, // 设置滚动条位置为顶部
        behavior: 'smooth' // 平滑滚动到顶部
    });
}